import {useEffect, useState} from "react";
import AppRouter from "./router";
import "./App.css";
import "./locales/i18n";
import {Termination} from "./pages";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

export const queryClient = new QueryClient();

const App = () => {
  const [isExpired, setIsExpired] = useState<boolean | null>(null);

  const checkSeason = () => {
    const now = new Date();
    // 2027년 1월 1일 00:00:00에 시즌 종료로 처리
    const targetTime = new Date("2026-02-09T18:58:00+09:00");
    // const targetTime = new Date("2027-01-01T00:00:00+09:00");
    if (now > targetTime) {
      setIsExpired(true);
      return;
    }
    setIsExpired(false);
  };

  useEffect(() => {
    checkSeason();
    const interval = setInterval(checkSeason, 10000); // 1분마다 체크

    return () => clearInterval(interval);
  }, []);

  if (isExpired === null) {
    return <div></div>; // 이후 로딩 또는 스켈레톤
  }

  if (isExpired) {
    return <Termination />;
  }
  return (
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
  );
};

export default App;
